import { useQuery } from "@tanstack/react-query";
import { api } from "@/api";

export const sellerKeys = {
	all: ["sellers"] as const,
	detail: (userId: string) => ["sellers", "detail", userId] as const,
	staff: (userId: string) => ["sellers", "staff", userId] as const,
	document: (userId: string, docId: string) => ["sellers", "document", userId, docId] as const,
	// Э7: «личное дело» — список документов продавца и байты отдельного файла.
	documents: (userId: string) => ["sellers", "documents", userId] as const,
	documentFile: (userId: string, docId: string) =>
		["sellers", "documentFile", userId, docId] as const,
	// Состояние верификации продавца (чек-лист документов + бейдж).
	verification: (userId: string) => ["sellers", "verification", userId] as const,
	// П7: разделы анкеты со статусами.
	sections: (userId: string) => ["sellers", "sections", userId] as const,
};

export function useSellers(enabled = true) {
	return useQuery({
		queryKey: sellerKeys.all,
		queryFn: () => api.sellers.list(),
		enabled,
	});
}

export function useSeller(userId: string) {
	return useQuery({
		queryKey: sellerKeys.detail(userId),
		queryFn: () => api.sellers.get(userId),
		enabled: !!userId,
	});
}

export function useSellerDocuments(userId: string) {
	return useQuery({
		queryKey: sellerKeys.documents(userId),
		queryFn: () => api.sellers.documents(userId),
		enabled: !!userId,
	});
}

export function useSellerVerification(userId: string) {
	return useQuery({
		queryKey: sellerKeys.verification(userId),
		queryFn: () => api.sellers.verification(userId),
		enabled: !!userId,
	});
}

export function useSellerStaff(userId: string) {
	return useQuery({
		queryKey: sellerKeys.staff(userId),
		queryFn: () => api.sellers.staff(userId),
		enabled: !!userId,
	});
}

/** П7 (fd-onboard-25/26): разделы анкеты продавца со статусами проверки. */
export function useSellerSections(userId: string) {
	return useQuery({
		queryKey: sellerKeys.sections(userId),
		queryFn: () => api.sellers.sections(userId),
		enabled: !!userId,
	});
}
